// One person, as a react-select option.
//
// Three pickers show people: the founders panel, the add-company form on the
// companies page, and the new-deal modal. Each had its own copy of the same
// label builder, so a person read as
// "Haris Ikram (hikram@candoriq.com) [SF] - CEO" in all three.
//
// The split that matters:
//
//   `label` is the text react-select SEARCHES. createFilter's default
//   stringify is `label + " " + value` and nothing else is consulted, so
//   every searchable field has to live in there. Shortening it to the name
//   would silently stop people finding anybody by email.
//
//   `name` is the person's name on its own. Use it for display, and anywhere
//   a name is written into a record: NewDealModal names a stealth company
//   after its first founder, and `label` put the email and title in the
//   company name.
//
//   formatPersonOption decides what the option LOOKS like, which is a name
//   with the email and title underneath. Display and search are separate
//   concerns in react-select, and this is where they part.
import React from 'react';
import './personOption.css';

export const personName = (person) =>
    `${person.first_name || ''} ${person.last_name || ''}`.trim() || 'Unnamed';

export const personSearchText = (person) =>
    [personName(person), person.email, person.title, person.location]
        .filter(Boolean)
        .join(' ');

export const personOption = (person) => ({
    value: person.id,
    label: personSearchText(person),
    name: personName(person),
    email: person.email || '',
    linkedin: person.linkedin || '',
    location: person.location || '',
    title: person.title || '',
});

// The name alone once picked, so a chosen person does not put their whole
// searchable string in the box.
export const formatPersonOption = (option, { context }) => {
    if (context === 'value') return option.name || option.label;
    const meta = [option.email, option.title].filter(Boolean).join(' · ');
    return (
        <span>
            <span className="person-option-name">{option.name || option.label}</span>
            {meta && <span className="person-option-meta">{meta}</span>}
        </span>
    );
};

export const NO_MATCHES = ({ inputValue }) =>
    inputValue.length < 2 ? 'Type to search' : 'No matches';
